export default __webpack_public_path__ + "static/media/ksivalue_main_mobile.05260f61.jpg";